module.exports = __webpack_public_path__ + "static/media/prev-course-history.a898281d.svg";